import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/integrations/mobly/services/csOs'

const findOne = (cod, organization) => AxiosClient.get(
  `${resource}/${cod}`, { headers: { organization } }
)

export {
  findOne
}
